<wiz-h-divider width="100%" height="100%" class="section-container-parent"> <!--c'est une sous-vue-->
  <wiz-vgroup width="100%" minWidth="600px" height="100%">
    <!-- parent -->
    <wiz-vgroup width="100%" >
      <wiz-vgroup width="100%" minHeight="0px" class="section-container" style="overflow: auto !important">
        <wiz-hgroup width="100%" padding="10px" gap="0" horizontalAlign="space-between">
          <!-- champ d'edition -->
          <wiz-vgroup style=" overflow: unset !important" gap="10"> <!-- neutralisation de l'overflow pour scroll du parent-->
            <wiz-hgroup #hgCodeLabel verticalAlign="center" gap="20" wizValidationContainer>
              <wiz-text-input
                #tiHeaderShortCode
                [wizValidator]="uniqueCodeValidator()"
                [wizMaxChars]="20"
                [wizLabel]="'$.chronocode.create.header.shortcode.$'"
                width="150px"
                [wizShowErrors]="true"
                [wizMandatory]="true"
                class="upper-case-input"
              ></wiz-text-input>
              <wiz-translation
                #tiHeaderLabel
                wizValidator
                width="200px"
                [wizLabel]="'$.chronocode.create.header.label.$'"
                [wizShowErrors]="true"
                [wizMandatory]="true"
              ></wiz-translation>
            </wiz-hgroup>

            <wiz-hgroup #hgTimeGap verticalAlign="center" gap="20" wizValidationContainer>
              <wiz-dropdown
                #ddlHeaderTimeGap
                wizValidator
                width="200px"
                [wizLabel]="'$.chronocode.create.header.timegap.$'"
                [wizDataProvider]="timegapDS"
                [wizLabelField]="'trsLabel'"
                [wizMandatory]="true"
              >
              </wiz-dropdown>
              <!-- dates -->
              <wiz-hgroup #hgDates gap="10" wizValidationContainer>
                <wiz-datefield
                  #dfHeaderStartDate
                  wizValidator
                  [wizFocusMode]="'PASS'"
                  [wizManualInput]="true"
                  [wizLabel]="'$.chronocode.start.date.$'"
                  [wizShowErrors]="true"
                  [wizMandatory]="true"
                ></wiz-datefield>
                <wiz-datefield
                  #dfHeaderEndDate
                  wizValidator
                  [wizManualInput]="true"
                  [wizLabel]="'$.chronocode.end.date.$'"
                  [wizShowErrors]="true"
                  [wizMandatory]="true"
                  [wizFocusMode]="'PASS'"
                ></wiz-datefield>
              </wiz-hgroup>
            </wiz-hgroup>
          </wiz-vgroup>

          <wiz-vgroup horizontalAlign="center" width="250px">
            <wiz-button
              #btCreateChronocode
              [wizIcon]="'arrow-right'"
              [iconPlacement]="'right'"
              [wizLabel]="'$.chronocode.create.valid.$'"
              width="100%"
              height="40px"
            ></wiz-button>
            <wiz-button
              #btnCancel
              class="cancel-button"
              [wizIcon]="'arrow-left'"
              [wizLabel]="'$.common.cancel.modification.$'"

              height="30px"
            ></wiz-button>     
            <wiz-spacer height="100%"></wiz-spacer>
            <wiz-button
              #btnGeneratePeriods
              [wizDisabled]="!canGenerate()"
              [wizLabel]="'$.chronocode.generate.periods.$'"
              (wizClick)="generatePeriods()"
              width="100%"
              height="40px"
            ></wiz-button>
            <wiz-button
              #btnNewLevel
              [wizIcon]="'add'"
              [wizLabel]="'$.chronocode.add.sub.level.$'"
              [wizDisabled]="!canGenerate()"
              [visible]="canAddSubLevel"
              width="100%"
              height="40px"
            ></wiz-button>
          </wiz-vgroup>
        </wiz-hgroup>
      </wiz-vgroup>
    </wiz-vgroup>

    <!-- affichage des sous-niveaux du chronocode -->
    <wiz-vgroup width="100%" height="100%" style="overflow: auto !important" gap="10">
      <ng-container *ngFor="let levelTemplate of template?.subLevels">
        <chrono-level-group [chroTemplate]="levelTemplate" width="100%" class="section-container"></chrono-level-group>
      </ng-container>
    </wiz-vgroup>
  </wiz-vgroup>

  <wiz-vgroup width="300px" minWidth="30px" height="100%">
    <wiz-tree #sampleTree width="100%" height="100%" class="sub-container"></wiz-tree>
  </wiz-vgroup>
</wiz-h-divider>
